const e="en-US",h={en:"en-US",es:"en-ES",zh:"zh-CN","zh-HK":"zh-TW","zh-TW":"zh-HK","zh-MO":"zh-HK",fr:"fr-FR",de:"de-DE",it:"it-IT",ru:"ru-RU",ja:"ja-JP"};export{e as DEFAULT_LOCALE,h as DEFAULT_LOCALE_FALLBACKS};
